module.exports = __webpack_public_path__ + "static/media/hrdlička7.ffd326ad.jpg";